import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'

import {BASE_CLASS, FORM_ID} from '../config.js'

/**
 * Search AI Quick Filters modal content (for small devices)
 * Use BasicModal on parent with this Footer and combined Content to avoid nested modals
 */
const SearchAiQuickFiltersModalFooter = ({isLoading, onCloseModal = () => {}}) => {
  const {i18n} = useContext(Context)

  return (
    <div className={`${BASE_CLASS}-modal-buttons`}>
      <AtomButton
        type="button"
        disabled={isLoading}
        onClick={onCloseModal}
        size={atomButtonSizes.LARGE}
        shape={atomButtonShapes.CIRCULAR}
        design={atomButtonDesigns.FLAT}
      >
        {i18n.t('COMMON.CANCEL')}
      </AtomButton>
      <AtomButton
        type="submit"
        form={FORM_ID}
        disabled={isLoading}
        size={atomButtonSizes.LARGE}
        shape={atomButtonShapes.CIRCULAR}
      >
        {i18n.t('COMMON.SHOW')}
      </AtomButton>
    </div>
  )
}

SearchAiQuickFiltersModalFooter.displayName = 'SearchAiQuickFiltersModalFooter'
SearchAiQuickFiltersModalFooter.propTypes = {
  isLoading: PropTypes.bool,
  onCloseModal: PropTypes.func
}

export default SearchAiQuickFiltersModalFooter
